<template>
  <div class="bg-brand-light-gray flex flex-col md:py-12">
    <div
      class="
        w-full
        md:max-w-screen-sm
        flex flex-col
        bg-white
        rounded-sm
        shadow
        mx-auto
        py-10
        px-10
        mt-5
      "
    >
      <img class="m-auto py-5" src="@/assets/images/complete.svg" />
      <h2 class="text-2xl py-1 text-center">Success</h2>
      <p class="py-3 text-center">You've successfully updated your password.</p>

      <div class="flex flex-col w-full md:w-1/2 mx-auto py-5">
        <router-link :to="{ name: 'home_login' }">
          <PrimaryButton>Go to login </PrimaryButton>
        </router-link>
      </div>
    </div>
  </div>
</template>
